import { LoadingDot } from "../../components/loading-dot.js";
import { ITEM_OPTIONS, USER_OPTIONS } from "../../config/constants.js";
import { FormatDescription } from "./model.js";

export class ItemsView {
  constructor() {
  }

  renderCollection(_items) {
    let html = '';
    for (let i = 0; i < _items.length; i++) {
      html += this.renderItem(_items[i]);
    }
    return html;
  }

  renderItem(_item) {
    let price = '';

    if (_item.precio && _item.moneda && _item.moneda != 0) {
      price = `<span class="price">${_item.moneda == '1' ? 'AR$' : 'U$D'} ${APICRUD.Common.FormatMoney(_item.precio, false, false)}</span>`;
    }
    let url = `/${_item.tipo.urlBase}/${_item.idcod}/${(_item.titulo || '').toLowerCase().replace(/ /g, '-')}`;

    if (_item.precio && _item.moneda && _item.moneda != 0) {
      _item.price = `${_item.moneda == '1' ? 'AR$' : 'U$D'} ${APICRUD.Common.FormatMoney(_item.precio, false, false)}`;
    }

    if (_item.nombreCategoria && _item.nombreCategoria.indexOf('<div') === -1) {
      _item.nombreCategoria = `
      <span class="category">
        ${_item.tipo.plural}
        > 
        ${_item.nombreCategoria}
      </span>`;
    }

    switch (_item.tipo.urlBase) {
      case "productos":
        if (_item.marca) {
          _item.marca = `<br><b>Marca: </b>${FormatDescription(_item.marca)}`;
        }
        if (_item['tiene-envio'] && _item['tiene-envio'] != '0') {
          let envio = ITEM_OPTIONS.TiposDeEnvios.find(i => i.value == _item['tiene-envio'])?.text || '';
          _item.envio = `<br><b>Tipo de envío: </b>${envio}`;
        }
        _item.texto = `
          ${_item.marca || ''}
          ${_item.envio || ''}
        `;
        break;
      case "maquinaria":
        if (_item.marca) {
          _item.marca = `<br><b>Marca: </b>${FormatDescription(_item.marca)}`;
        }
        if (_item.kilometros) {
          _item.kilometros = `<br><b>Kilómetros: </b>${FormatDescription(_item.kilometros)}`;
        }
        if (_item.modelo) {
          _item.modelo = `<br><b>Modelo: </b>${FormatDescription(_item.modelo)}`;
        }
        if (_item.anio) {
          _item.anio = `<br><b>Año: </b>${FormatDescription(_item.anio)}`;
        }
        _item.texto = `
          ${_item.kilometros || ''}
          ${_item.marca || ''}
          ${_item.modelo || ''}
          ${_item.anio || ''}
        `;
        break;
      case "inmuebles":
        if (_item.metros) {
          _item.metros = `<br><b>Superficie: </b>${FormatDescription(_item.metros)}`;
        }
        _item.texto = `
          ${_item.metros || ''}
        `;
        break;
      case "servicios":
        if (_item.radio) {
          _item.radio = `<br><b>Radio de acción: </b>${FormatDescription(_item.radio)}`;
        }

        if (_item.maquinas) {
          _item.maquinas = `<br><b>Maquinaria: </b>${FormatDescription(_item.maquinas)}`;
        }

        if (_item.software) {
          _item.software = `<br><b>Software: </b>${FormatDescription(_item.software)}`;
        }

        _item.texto = `
          ${_item.radio || ''}
          ${_item.maquinas || ''}
          ${_item.software || ''}
        `;
        break;
    }
    let puntuacion = Math.random() * (5 - 4) + 4;
    return `
      <article>
        <a href="${url}" class="item">
          <div id="slider-${_item.idcod}"></div>
          <div style="padding: 14px 20px 0px 20px">
            <span class="entity">${_item.nombreCategoria}</span>
            <div class="fr">${window.app.starsController.renderOne(puntuacion)}</div>
          </div>
          <h1>
            ${_item.titulo || 'Sin título'}
          </h1>
          <p>${price}</p>
          <p> <span class="location">${_item.city || ''}</span> </p>
          <p>${_item.resumen || ''}</p>
          <p>${_item.texto || ''}</p>
        </a >
      <div class="user user-${_item.idcodUserCreate}">
        <a href="" class="profile">
          <img src="/assets/img/user.jpg" alt="">
            <div>
              <div class="name">${LoadingDot.render()}</div>
              <div class="occupation"></div>
            </div>
        </a>
        <div class="actions">
        </div>
      </div>
      </article >
  `;
  }

  renderItemDetail(_data) {
    if (_data.descripcion) {
      _data.descripcion = `<hr> <pre>${_data.descripcion}</pre>`;
    }

    if (_data.nombreCategoria && _data.nombreCategoria.indexOf('<div') === -1) {
      _data.nombreCategoria = `
    <div class="category">
    <a href="/${_data.tipo.urlBase}">${_data.tipo.plural}</a>
    >
    ${_data.nombreCategoria}
      </div > `;
    }


    if (_data.precio && _data.moneda && _data.moneda != 0) {
      _data.price = `${_data.moneda == '1' ? 'AR$' : 'U$D'} ${APICRUD.Common.FormatMoney(_data.precio, false, false)} `;
    }

    switch (_data.tipo.urlBase) {
      case "productos":
        if (_data.medida && _data.unidad) {
          let unidad = ITEM_OPTIONS.Unidades.Productos.find(i => i.value == _data.unidad)?.text || '';
          _data.medida = `<pre><hr><h3>Cantidad</h3>${_data.medida} ${unidad}</pre>`;
        }
        if (_data.marca) {
          _data.marca = `<pre><hr><h3>Marca</h3>${FormatDescription(_data.marca)}</pre>`;
        }
        if (_data['tiene-envio'] && _data['tiene-envio'] != '0') {
          let envio = ITEM_OPTIONS.TiposDeEnvios.find(i => i.value == _data['tiene-envio'])?.text || '';
          _data.envio = `<pre><hr><h3>Tipo de envío</h3>${envio}</pre>`;
        }
        _data.texto = `
          ${_data.medida || ''}
          ${_data.marca || ''}
          ${_data.envio || ''}
`;
        break;
      case "maquinaria":
        if (_data.marca) {
          _data.marca = `<pre><hr><h3>Marca</h3>${FormatDescription(_data.marca)}</pre>`;
        }
        if (_data.kilometros) {
          _data.kilometros = `<pre><hr><h3>Kilómetros</h3>${FormatDescription(_data.kilometros)}</pre>`;
        }
        if (_data.modelo) {
          _data.modelo = `<pre><hr><h3>Modelo</h3>${FormatDescription(_data.modelo)}</pre>`;
        }
        if (_data.anio) {
          _data.anio = `<pre><hr><h3>Año</h3>${FormatDescription(_data.anio)}</pre>`;
        }
        _data.texto = `
          ${_data.kilometros || ''}
          ${_data.marca || ''}
          ${_data.modelo || ''}
          ${_data.anio || ''}
`;
        break;
      case "inmuebles":
        if (_data.metros) {
          _data.metros = `<pre><hr><h3>Superficie</h3>${FormatDescription(_data.metros)}</pre>`;
        }
        _data.texto = `
          ${_data.metros || ''}
`;
        break;
      case "servicios":
        if (_data.radio) {
          _data.radio = `<pre><hr><h3>Radio de acción</h3>${FormatDescription(_data.radio)}</pre>`;
        }

        if (_data.maquinas) {
          _data.maquinas = `<pre><hr><h3>Maquinaria</h3>${FormatDescription(_data.maquinas)}</pre>`;
        }

        if (_data.software) {
          _data.software = `<pre><hr><h3>Software</h3>${FormatDescription(_data.software)}</pre>`;
        }

        _data.texto = `
          ${_data.radio || ''}
          ${_data.maquinas || ''}
          ${_data.software || ''}
`;
        break;
    }

    _data.user.image = APICRUD.Image.GetUrl(_data.user.image);
    if (_data.user.image && _data.user.image.indexOf('/.jpg') > -1) {
      _data.user.image = '/assets/img/user.jpg';
    }
    if (_data.user.image === '') {
      _data.user.image = '/assets/img/user.jpg';
    }
    return `
      <div class="item-detail box detail">
        <div class="item-header">
          <div class="category">${_data.nombreCategoria}</div>
          <div class="date">${_data.fecha}</div>
        </div>
        <div class="title">${_data.titulo}</div>
        <div class="location">${_data.city || ''} </div>
        <div class="visor">
          <div id="slider-${_data.idcod}" > </div>
        </div>
        <div class="price">${_data.price || ''}</div>
        <button class="contactar-wsp" onclick="window.open('https://wa.me/${ClearPhone(_data.user.phone)}?text=Hola,%20quiero%20saber%20más%20sobre%20${_data.titulo?.replace(/ /g, '%20')}%20que%20ví%20en%20agrolabores.com', '_blank')">Contactar por WhatsApp</button>
        <pre>${_data.resumen || ''}</pre>
        <div class="caracteristicas">${_data.texto}</div>
        <p>${_data.descripcion || ''}</p>
      </div >
      <div class="box side">
        <div class="side-sticky" id="datosDelProveedor">
          <h1>Datos del proveedor</h1>
          <article>
            <hr>
            <div class="user user-${_data.idcodUserCreate}" type='user-full'>
              <a href="" class="profile">
                <img src="/assets/img/user.jpg" alt="">
                  <div>
                    <div class="name">${LoadingDot.render()}</div>
                    <div class="occupation"></div>
                    <div></div>
                  </div>
              </a>
              <hr>
              <div class="actions">
              </div>
              <hr>
            </div>
          </article>
          <aside id="banner3" class="banner3">
            

          </aside>
        </div>
      </div>
    `;
  }
}

export class ItemsViewUserInfo {
  constructor(_idcodUser, _title, _user_deleted) {
    this.title = _title;
    this.intents = 0;
    this.idcodUser = _idcodUser;
    if (_user_deleted == 1) {
      this.render(true);
    } else {
      this.Load();
    }
  }

  async Load() {
    this.user = await app.userPrivateController.auth.getInfoUserFromIdcod(this.idcodUser);
    this.user.occupation = USER_OPTIONS.Cargos.find(i => i.value == this.user.occupation)?.text || '';
    if (this.user.occupation.indexOf('--') > -1) {
      this.user.occupation = '';
    }
    this.user.image = APICRUD.Image.GetUrl(this.user.image);
    if (this.user.image && this.user.image.indexOf('/.jpg') > -1) {
      this.user.image = '/assets/img/user.jpg';
    }
    if (this.user.image === '') {
      this.user.image = '/assets/img/user.jpg';
    }
    if (window.location.href.indexOf('/perfil/' + this.user.permalink) > -1) {
      let doms = document.getElementsByClassName('user-' + this.idcodUser);
      if (doms.length > 0) {
        for (let i = 0; i < doms.length; i++) {
          doms[i].setAttribute('style', 'opacity: 0; height: 0px; padding: 8px; overflow: hidden; ');
        }
      }

      return;
    }
    this.render(false);
  }

  render(_isUserDeleted) {
    let doms = document.getElementsByClassName('user-' + this.idcodUser);
    if (doms.length > 0) {
      for (let i = 0; i < doms.length; i++) {
        if (_isUserDeleted === true) {
          this.html = `
          <a href="#" class="profile">
            <img src="/assets/img/user.jpg" alt="Usuario Anónimo">
              <div>
                <div class="name">Usuario anónimo</div>
                <div class="occupation">Este usuario ha eliminado su cuenta.</div>
              </div>
          </a>
        `;
        } else {
          let text1 = "";
          let text2 = "";
          let linkWhatsApp = '';
          if (doms[i].getAttribute('type') === 'user-full') {
            text1 = "Enviar mensaje al WhatsApp";
            text2 = this.user.phone || 'Sin definir.';
          }
          if (this.user.phone) {
            linkWhatsApp = `https://wa.me/${ClearPhone(this.user.phone)}?text=Hola,%20quiero%20saber%20más%20sobre%20${this.title?.replace(/ /g, '%20')}%20que%20ví%20en%20agrolabores.com`;
          } else {
            linkWhatsApp = '#';
            if (doms[i].getAttribute('type') === 'user-full') {
              text1 = 'Sin definir.';
            }
          }
          this.html = `
          <a href="/perfil/${this.user.permalink}" class="profile">
            <img src="${this.user.image}" alt="${this.user.name}">
              <div>
                <div class="name">${this.user.name}</div>
                <div class="occupation">${this.user.occupation}</div>
              </div>
          </a>
          <div class="actions">
            <a href="${linkWhatsApp}" class="whatsapp" target="_blank">${text1}</a>
            <a href="callto:${this.user.phone}" class="phone">${text2}</a>
          </div>
        `;
        }

        doms[i].innerHTML = this.html;
      }
    } else if (this.intents < 20) {
      this.intents++;
      setTimeout(this.render.bind(this), 1500, _isUserDeleted);
    }
  }
}


export function ClearPhone(_phone) {
  _phone = _phone || '';
  return _phone.replace('+', '').replace(/ /g, '').replace(/-/g, '');
}
